import { useQuery } from '@apollo/client';
import { ConfirmationServiceProvider } from '@website/components/utilities/ConfirmationService';
import ErrorPage from '@website/components/utilities/ErrorPage';
import LoadingPage from '@website/components/utilities/LoadingPage';
import { CancellationOptionsDocument } from '@website/types/graphqlOperations';
import Link from 'next/link';
import { Breadcrumb, Col, Row, Spinner } from 'react-bootstrap';
import CancellationForm from './cancellationForm/CancellationForm';

/**
 * User Booking Details Page Content
 */
export default function CancelBooking({ query }) {
  const { bookingId } = query;

  // Get the booking cancellation options for each space
  const { data, loading, error } = useQuery(CancellationOptionsDocument, {
    variables: { id: bookingId },
    fetchPolicy: 'network-only',
  });

  // Show spinner if loading
  if (loading || error) return <Spinner animation="border" />;

  // Handle loading/errors
  if (loading && !data) {
    return <LoadingPage />;
  }

  if (error && !data) {
    return <ErrorPage error={error} />;
  }

  return (
    <>
      <Row>
        <Col md={7} className="mb-3">
          <Breadcrumb listProps={{ className: 'ps-0 justify-content-start' }}>
            <Link href="/" passHref legacyBehavior>
              <Breadcrumb.Item>Home</Breadcrumb.Item>
            </Link>
            <Link href={`/me/${query.userID}`} passHref legacyBehavior>
              <Breadcrumb.Item>Your dashboard</Breadcrumb.Item>
            </Link>
            <Link
              href={`/me/${query.userID}/bookings/${query.bookingId}`}
              passHref
              legacyBehavior
            >
              <Breadcrumb.Item>Booking {query.bookingId}</Breadcrumb.Item>
            </Link>
            <Breadcrumb.Item active>Cancel Booking</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <h1>Cancellation Options</h1>
      <ConfirmationServiceProvider>
        <CancellationForm booking={data.booking} />
      </ConfirmationServiceProvider>
    </>
  );
}
